import { ReactNode } from 'react';

import classes from './index.module.scss';

interface Props {
  children: ReactNode;
}

const ErrorFallback = ({ children }: Props) => {
  return <div className={classes.container}>{children}</div>;
};

export default ErrorFallback;
